import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ResizableColumns from "../../../components/FallComponents/ResizableColumns/ResizableColumns";
import { useFilter } from "../../../hooks/useFilter";
import isEmpty from "is-empty";
import AllAcuantData from "../../../components/FallComponents/AcuantPage/AllAcuantData";
import AcuantController from "../../FallControllers/AcuantController";
import ComponentsHelper from "../../../helpers/Components.helper";
import { toastTypes } from "../../../constants";

const AcuantPage = (props, context) => {
  const { userInfo } = props;

  const [withRightSection, setWithRightSection] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const {
    filterSearch,
    filterConfig,
    offset,
    showingTo,
    changePage,
    onChangeLimit,
    setFilterSearch,
    resetFilters,
  } = useFilter({
    totalRows,
    filterConfigUrl: {
      limit: 100,
      page: 1,
    },
  });

  const getAllClients = () => {
    AcuantController.getAllClients({
      userInfo,
      setLoading,
      setRows,
      setTotalRows,
      filterConfig,
      filterSearch,
    });
  };

  const sendRowsBySelection = async () => {
    const arrayCheckbox = document.getElementsByClassName(
      "input-check-select-acuant"
    );
    let selectedsArray = [];
    for (let item of arrayCheckbox) {
      if (item.checked) {
        selectedsArray.push(Number(item.name));
      }
    }
    if (selectedsArray.length < 1) {
      ComponentsHelper.toast({type:toastTypes.warn,message:"Seleccione un registro para enviar a Acuant"})
      return
    }
    AcuantController.createAcuantQueue({ userInfo, ids: selectedsArray  });
  };

  useEffect(() => {
    if (isEmpty(userInfo)) return;
    getAllClients();
  }, [userInfo, filterConfig, filterSearch]);

  return (
    <div className="beta-content-container">
      <ResizableColumns
        withRightSection={withRightSection}
        childrenOne={
          <AllAcuantData
            setWithRightSection={setWithRightSection}
            withRightSection={withRightSection}
            onChangeLimit={onChangeLimit}
            filterConfig={filterConfig}
            filterSearch={filterSearch}
            totalRows={totalRows}
            rows={rows}
            loading={loading}
            offset={offset}
            showingTo={showingTo}
            changePage={changePage}
            setFilterSearch={setFilterSearch}
            resetFilters={resetFilters}
            sendRowsBySelection={sendRowsBySelection}
          />
        }
      />
    </div>
  );
};

const mapStateToProps = ({ user: { userInfo } }) => {
  return { userInfo };
};

AcuantPage.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AcuantPage);
